require("./sensing_mousex.js");
require("./sensing_mousey.js");
require("./sensing_mousedown.js");
require("./sensing_keyoptions.js");
require("./sensing_keypressed.js");
require("./sensing_touchingobjectmenu.js");
require("./sensing_touchingobject.js");
